import axiosInstance from "../config/axios/axios.config";

/**
 * Axios 0.21 serializes array params as `status[]=a&status[]=b`. Django/DRF's
 * FilterSerializer expects the field name `status`, i.e. repeated `status=a&status=b`.
 * Without this, admin list filters and date+status combinations may not match rows.
 */
function adminApplicationsAdminParamsSerializer(params) {
  const parts = [];
  Object.keys(params).forEach((key) => {
    const val = params[key];
    if (val === null || val === undefined) return;
    if (Array.isArray(val)) {
      val.forEach((item) => {
        parts.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(item)}`
        );
      });
    } else {
      parts.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
      );
    }
  });
  return parts.join("&");
}

export const ApplicationList = (id) => {
  return axiosInstance.get(`/core/get-vendor-applications/?vendor_id=${id}`);
};

export const CreateVendorApplication = (payload) => {
  return axiosInstance.post(`/core/create-vendor-application/`, payload);
};

export const UpdateVendorApplication = (payload) => {
  return axiosInstance.put(`/core/update-vendor-application/`, payload);
};

export const AttachVendorProfile = (vendorId, applicationId) => {
  const params = { vendor_id: vendorId, application_id: applicationId };
  return axiosInstance.get(`/core/attach-vendor-profile/`, { params });
};

export const recertificationAttest = (applicationId) => {
  return axiosInstance.post(`/core/recertification/attest/`, {
    application_id: applicationId,
  });
};

export const adminApplicationList = (queryParams) => {
  let queryString = `/core/get-vendor-applications-admin/`;
  return axiosInstance.get(queryString, {
    params: {
      ...queryParams,
    },
    paramsSerializer: adminApplicationsAdminParamsSerializer,
  });
};

export const downloadPqqData = (queryParams) => {
  let queryString = `/core/get-vendor-applications-admin/`;
  return axiosInstance.get(queryString, {
    responseType: "blob",
    params: queryParams,
    paramsSerializer: adminApplicationsAdminParamsSerializer,
  });
};

export const getApplicationById = (id) => {
  return axiosInstance.get(
    `/core/get-vendor-application/?application_id=${id}`
  );
};

export const adminUpdateApplicationById = (payload) => {
  return axiosInstance.put(`/core/admin-update-vendor-application/`, payload);
};

export const getActivity = (id) => {
  return axiosInstance.get(`/core/get-activity/?vendor_id=${id}`);
};

export const getVendorProfile = (id) => {
  return axiosInstance.get(`/core/get-vendor-profile/?application_id=${id}`);
};

export const adminVendorMapping = (id, payload) => {
  return axiosInstance.put(
    `/accounts/update-vendor-and-user-mappings/${id}/`,
    payload
  );
};

export const downloadVendorProfile = (id) => {
  return axiosInstance.get(
    `/core/download-vendor-profile/?application_id=${id}`,
    {
      responseType: "blob",
    }
  );
};

export const updateSkipTour = (payload) => {
  return axiosInstance.put(`/core/skip-tour/`, payload);
};

export const getAllAdmins = () => {
  return axiosInstance.get(`/accounts/get-admins-list/`);
};

export const getUsersList = () => {
  return axiosInstance.get(`/accounts/get-users-list/`);
};

export const getVendorsListAdmin = () => {
  return axiosInstance.get(`/core/get-vendors-admin/`);
};

export const downloadVendorsAdminListData = () => {
  return axiosInstance.get(`/core/get-vendors-admin/?download_data=true`, {
    responseType: "blob",
  });
};

export const deletePQQApi = (pqq_id) => {
  return axiosInstance.delete(`/core/delete-pqq/${pqq_id}/`);
};

export const populateTestProfile = (vendorId) => {
  return axiosInstance.post(`/core/populate-test-profile/`, { vendor_id: vendorId });
};

export const getAnalytics = (queryParams = {}) => {
  return axiosInstance.get(`/core/analytics/`, { params: queryParams });
};
